import { useCallback, useMemo } from 'react';
import { useDeleteEntityDocumentMutation } from '@/modules/entity/queries/entity.tsx';
import { DropZoneSingle, Dropzone } from 'ui';
import { EntityDocumentWithUrl } from 'api';

interface DocumentDropzoneProps extends DropZoneSingle {
  type: string;
  entityId: number;
  initDocs: EntityDocumentWithUrl[];
}

const DocumentDropzone = ({
  type,
  value,
  error,
  entityId,
  initDocs,
  onFileClear,
  onFileAccepted,
  loading,
  disabled,
}: DocumentDropzoneProps) => {
  const { mutateAsync, isLoading } = useDeleteEntityDocumentMutation({ onSuccess: onFileClear });

  const initDoc = useMemo(() => (initDocs || []).find(doc => doc.type === type), [initDocs, type]);

  const handleClear = useCallback(async () => {
    if (initDoc) {
      await mutateAsync({ entity_id: entityId, type: type, index: initDoc.index });
    } else {
      onFileClear();
    }
  }, [entityId, initDoc, mutateAsync, onFileClear, type]);

  return (
    <Dropzone
      value={value ?? initDoc?.url}
      onFileAccepted={onFileAccepted}
      onFileClear={handleClear}
      error={error}
      loading={isLoading || loading}
      disabled={isLoading || disabled}
    />
  );
};

export default DocumentDropzone;
